import Http from '../core/axios'

const accountHost = process.env.VUE_APP_ACCOUNT_HOST
const apiHost = process.env.VUE_APP_BASE_API
const ng = process.env.VUE_APP_CURRENT_MODE === 'local' ? '/local' : ''
const consoleSpace = `${ng}/console_space`

// params 转为query
function toQuery(url, params) {
  let urlParams = []
  Object.keys(params).forEach((key) => {
    // 如果值为空，则不传该属性
    if (params[key] || params[key] === 0 || params[key] === false) {
      urlParams.push(`${key}=${encodeURIComponent(params[key])}`)
    }
  })
  if (urlParams.length) {
    urlParams = url.includes('?') ? `${url}&${urlParams.join('&')}` : `${url}?${urlParams.join('&')}`
  } else {
    urlParams = url
  }
  return urlParams
}

const newApi = {
  // 不接入插件的埋点
  tracks(params, headers = {}) {
    return Http.post(`${apiHost}/tracks`, params, headers)
  },
  // 用户信息
  user: {
    logoutPlugin(headers = {}) {
      return Http.axDelete(`${accountHost}/authcode`, headers)
    },
    logout(dest) {
      return Http.axDelete(`${accountHost}/session${toQuery('', dest)}`)
    },
    userInfoRefresh(headers = {}) {
      return Http.patch(`${accountHost}/users/refresh`, {}, headers)
    },
    getUserInfo(headers = {}) {
      return Http.get(`${accountHost}/users/info?role=0`, {}, headers)
    },
    getLoginToken() {
      return Http.post(`${accountHost}/login_token`)
    },
    getUserDetail() {
      return Http.get(`${accountHost}/users/details`)
    },
    ssoUrl(dest) {
      return Http.get(`${accountHost}/sso/url${toQuery('', dest)}`)
    },
    getUserInfoBySso(params) {
      return Http.post(`${accountHost}/sso/session?role=0`, params, { 'Content-Type': 'text/plain' })
    },
    updateUser(body) {
      return Http.put(`${accountHost}/users/details`, body)
    },
  },
  /** 空间管理 **/
  space: {
    // 获取空间列表
    getTeamSpaces(query) {
      return Http.get(`${apiHost}/team_spaces`, query)
    },
    // 新建空间
    addTeamSpaces(params) {
      return Http.post(`${apiHost}/team_spaces`, params)
    },
    // 修改空间
    editTeamSpaces(id, params) {
      return Http.put(`${apiHost}/team_spaces/${id}`, params)
    },
    // 获取空间信息
    getSpacesDetail(id) {
      return Http.get(`${apiHost}/team_spaces/${id}`)
    },
    // 解散空间
    disbandSpaces(id) {
      return Http.axDelete(`${apiHost}/team_spaces/${id}/disband`)
    },
    // 退出空间
    quitSpaces(id) {
      return Http.post(`${apiHost}/team_spaces/${id}/quit`)
    },
  },
  auth: {
    check(query) {
      return Http.get(`${consoleSpace}/users/check`, query, false)
    },
    // 获取用户信息及权限
    getUserInfo() {
      return Http.get(`${consoleSpace}/v1/users/info`)
    },
    // 获取空间信息（空间品牌、适配软件等信息，不包含设置信息）
    getSpaceInfo() {
      return Http.get(`${consoleSpace}/info`)
    },
  },
  resource: {
    // 获取空间资源列表 - 分页
    getSpaceResources(space_id, params) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources`, params)
    },
    // 获取聚合空间资源的扩展属性值列表
    getPropertyValues(space_id, params) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/filters/property_values`, params)
    },
    // 获取当前用户有权限的目录列表
    getSpacePlatClassify(params) {
      return Http.get(`${apiHost}/team_space/${params.space_id}/space/resource_categories`, params)
    },
    // 获取聚合目录
    getSpaceClassifiesAgg(params) {
      return Http.get(`${apiHost}/team_space/${params.space_id}/content/space_resources/space_categories`, params)
    },
    // 空间自定义分类创建
    customCategories(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/space/custom_categories`, params)
    },
    // 空间自定义分类更新
    updateCustomCategories(space_id, id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/space/custom_categories/${id}/name`, params)
    },
    // 空间自定义分类删除
    deleteCustomCategories(space_id, id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/custom_categories/${id}`)
    },
    // 资源删除
    deleteSpaceResources(space_id, resource_software_version_id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/space_resources/${resource_software_version_id}`)
    },
    // 资源批量删除
    deleteResourceBatch(space_id, operation_key) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/batch/operation_key/${operation_key}/resources`)
    },
    // 创建空间资源
    createResource(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/space_resources`, params)
    },
    // 更新空间资源
    renewalResource(space_id, space_resource_id, resource_software_version_id, params) {
      return Http.put(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/renewal`, params)
    },
    // 获取空间资源详情
    getSpaceResourceDetail(space_id, space_resource_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}`)
    },
    // 获取版本资源详情
    getSpaceResourceVersionDetail(space_id, space_resource_id, resource_software_version_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}`)
    },
    // 获取版本资源文件详情
    getSpaceResourceVersionFile(space_id, space_resource_id, resource_software_version_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/files`)
    },
    // 获取版本资源参数类型详情
    getSpaceResourceVersionParameters(space_id, space_resource_id, resource_software_version_id, parameter_type_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/parameter_types/${parameter_type_id}/parameter_type_values`)
    },
    // 获取指定软件版本数据版本、操作记录
    getSpaceResourceDataVersions(space_id, space_resource_id, resource_software_version_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/record`)
    },
    // 获取单个下载资源接口
    getDownloadUrl(space_id, space_resource_id, resource_software_version_id, data_version_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/download_url`, data_version_id ? { data_version_id } : '')
    },
    // 获取批量下载资源接口
    batchDownload(space_id, operation_key) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/batch/operation_key/${operation_key}/resources/download_urls`)
    },
    // 获取批量修改操作key
    getBatchOperationKey(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/batch/operations`, params)
    },
    // 移动
    spaceCategory(space_id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/space_resources/space_category`, params)
    },
    // 批量移动
    spaceBatchCategory(space_id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/batch/space_category`, params)
    },
    // 启用数据版本
    enableDataVersion(space_id, space_resource_id, resource_software_version_id, data_version_id) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/data_versions/${data_version_id}/enable`)
    },
    // 删除数据版本
    delDataVersion(space_id, space_resource_id, resource_software_version_id, data_version_id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/data_versions/${data_version_id}/delete`)
    },
    // 设置主图
    updateFavouriteThumbnail(space_id, space_resource_id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/favourite_thumbnail`, params)
    },
    // 修改名称
    updateName(space_id, space_resource_id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/name`, params)
    },
    // 修改名称
    checkMD5(space_id, space_resource_id, resource_software_version_id, md5) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/${space_resource_id}/resource_software_versions/${resource_software_version_id}/check_md5/${md5}`)
    },
    // 空间下是否有资源
    hasResources(space_id, space_category_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/has_resources`, { space_category_id })
    },
    // 降级
    downgrades(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/space_resources/downgrades`, params)
    },
    // 获取降级信息
    getDowngradesInfo(space_id, id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/downgrades/${id}`)
    }
  },
  file: {
    // 获取文件筛选器类型列表
    fileTypeTags(space_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/file_types`)
    },
    // 获取文件列表
    getFilesList(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/files/list`, params)
    },
    // 新建文件夹或上传文件
    createFile(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/files`, params)
    },
    // 更新文件
    renewalFile(space_id, file_id, params) {
      return Http.put(`${apiHost}/team_space/${space_id}/content/files/${file_id}/renewal`, params)
    },
    // 删除文件夹或文件
    deleteFile(space_id, file_id, params) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/files/${file_id}/delete`, params)
    },
    // 批量删除文件夹和文件
    batchDeleteFiles(space_id, operation_key, params) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/files/batch/operation_key/${operation_key}/delete`, params)
    },
    // 重命名文件夹或文件
    renameFiles(space_id, file_id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/files/${file_id}/rename`, params)
    },
    // 查询指定文件夹下是否存有重名内容（只看一层）
    namesakeFile(space_id, file_id, params) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/namesake`, params)
    },
    // 批量移动
    moveFile(space_id, operation_key, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/files/batch/operation_key/${operation_key}/move?source_parent_id=${params.source_parent_id}&target_parent_id=${params.target_parent_id}`)
    },
    // 获取版本记录
    getVersionRecords(space_id, file_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/records`)
    },
    // 获取文件的下载地址或指定修订版本的下载地址
    versionRecordsDownload(space_id, file_id, fileRevisionId) {
      if (fileRevisionId) {
        return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/download?file_revision_id=${fileRevisionId}`)
      } else {
        return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/download`)
      }
    },
    // 启用数据版本
    startNewVersion(space_id, file_id, revision_id) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/files/${file_id}/revisions/${revision_id}/enable`)
    },
    // 删除修订版本
    deleteVersionRecord(space_id, file_id, revision_id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/files/${file_id}/revisions/${revision_id}/delete`)
    },
    getFilePath(space_id, file_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/path`)
    },
    // 查询某个空间下是否有文件
    hasFiles(space_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/has_files`)
    },
    // 批量下载文件接口
    batchDownload(space_id, operation_key) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/batch/operation_key/${operation_key}/download_urls`)
    },
    // 获取当前启用的修订版本
    enableRevision(space_id, file_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/enable_revision`)
    },
    // 获取文件某版本的详情
    revisionInfo(space_id, file_id, revision_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/revisions/${revision_id}`)
    },
    // 轻量化转换
    translate(space_id, file_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/files/${file_id}/translate`, params)
    },
    // 获取bimface的viewToken
    viewToken(space_id, file_id, revision_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/revisions/${revision_id}/view_token`)
    },
    // 查看分享链接接口
    queryShareCode(space_id, file_id, query) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/shares`, query)
    },
    // 生成分享链接接口
    createShareCode(space_id, file_id, query) {
      return Http.post(toQuery(`${apiHost}/team_space/${space_id}/content/files/${file_id}/shares`, query))
    },
    // 修改（取消）分享链接接口
    modifyShareCode(space_id, file_id, share_code, query) {
      return Http.put(toQuery(`${apiHost}/team_space/${space_id}/content/files/${file_id}/shares/${share_code}`, query))
    },
    // 获取分享信息接口
    shareInfo(share_code) {
      return Http.get(`${apiHost}/team_space_share/${share_code}`)
    },
    // 获取合模方案分享信息接口
    federationPlanShareInfo(share_code) {
      return Http.get(`${apiHost}/team_space_share/federation_plans/${share_code}`)
    },
    // 获取整合模型分享信息接口
    integratedModelShareInfo(share_code) {
      return Http.get(`${apiHost}/team_space_share/integrated_models/${share_code}`)
    },
    // 获取所有目录及轻量化成功的文件
    federationPlanFiles(space_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/federation_plans/files`)
    },
    // 获取合模方案列表
    federationPlanList(space_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/federation_plans/list`)
    },
    // 新建合模方案
    createFederationPlan(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/federation_plans`, params)
    },
    // 合模方案校验
    checkFederationPlan(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/federation_plans/check`, params)
    },
    // 合模方案预览
    previewFederationPlan(space_id, params) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/federation_plans/preview`, params)
    },
    // 获取合模方案详情
    federationPlanInfo(space_id, id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/federation_plans/${id}`)
    },
    // 删除合模方案
    deleteFederationPlan(space_id, id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/federation_plans/${id}/delete`)
    },
    // 合模方案移除文件
    removeFederationPlanFile(space_id, id, file_id) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/federation_plans/${id}/remove_file/${file_id}`)
    },
    // 重命名合模方案
    renameFederationPlan(space_id, id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/federation_plans/${id}/rename`, params)
    },
    // 合模方案修改合模文件
    updateFederationPlanFile(space_id, id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/federation_plans/${id}/update`, params)
    },
    // 发布合模方案
    publishFederationPlan(space_id, id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/federation_plans/${id}/release`, params, {}, true)
    },
    // 获取整合模型列表
    integratedModelList(space_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/integrated_models/list`)
    },
    // 获取整合模型详情
    integratedModelInfo(space_id, id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/integrated_models/${id}`)
    },
    // 删除整合模型
    deleteIntegratedModel(space_id, id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/integrated_models/${id}/delete`)
    },
    // 重命名整合模型
    renameIntegratedModel(space_id, id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/integrated_models/${id}/rename`, params)
    },
    // 重新转换整合模型
    translateIntegratedModel(space_id, id) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/integrated_models/${id}/translate`)
    },
    // 文件生成离线包
    createFileOfflinePackage(space_id, file_id, revision_id) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/files/${file_id}/revisions/${revision_id}/generate_offline_package`, null, null, true)
    },
    // 获取文件离线包下载地址
    getFileOfflinePackageUrl(space_id, file_id, revision_id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/files/${file_id}/revisions/${revision_id}/download_offline_package`)
    },
    // 交付模型生成离线包
    createOfflinePackage(space_id, id) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/integrated_models/${id}/generate_offline_package`, null, null, true)
    },
    // 获取离线包下载地址
    getOfflinePackageUrl(space_id, id) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/integrated_models/${id}/download_offline_package`)
    },
  },
  // 文件模型视点
  viewpoint: {
    // 根据 fileId 获取视点列表
    list(space_id, query) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/view_points`, query)
    },
    // 根据 shareCode 获取视点列表
    listByShareCode(share_code) {
      return Http.get(`${apiHost}/team_space_share/${share_code}/view_points`)
    },
    // 添加视点
    create(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/view_points`, params)
    },
    // 删除视点
    remove(space_id, id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/view_points/${id}/delete`)
    },
    // 编辑视点
    update(space_id, id, params) {
      return Http.patch(`${apiHost}/team_space/${space_id}/content/view_points/${id}/rename`, params)
    },
  },
  // 文件模型批注
  annotation: {
    // 获取批注列表
    list(space_id, query) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/comments`, query)
    },

    // 添加批注
    create(space_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/comments`, params)
    },

    // 回复批注
    reply(space_id, comment_id, params) {
      return Http.post(`${apiHost}/team_space/${space_id}/content/comments/${comment_id}/replies`, params)
    },

    // 删除回复
    deleteReply(space_id, comment_id, reply_id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/comments/${comment_id}/replies/${reply_id}/delete`)
    },

    // 删除批注
    deleteAnnotation(space_id, comment_id) {
      return Http.axDelete(`${apiHost}/team_space/${space_id}/content/comments/${comment_id}/delete`)
    },

    // 分享页获取批注列表
    listByShareCode(share_code, query) {
      return Http.get(`${apiHost}/team_space_share/${share_code}/comments`, query)
    },

    // 分享页添加批注
    createByShareCode(share_code, params) {
      return Http.post(`${apiHost}/team_space_share/auth/${share_code}/comments`, params)
    },

    // 分享页回复批注
    replyByShareCode(share_code, comment_id, params) {
      return Http.post(`${apiHost}/team_space_share/auth/${share_code}/comments/${comment_id}/replies`, params)
    },

    // 分享页删除回复
    deleteReplyByShareCode(share_code, comment_id, reply_id) {
      return Http.axDelete(`${apiHost}/team_space_share/auth/${share_code}/comments/${comment_id}/replies/${reply_id}/delete`)
    },

    // 分享页删除批注
    deleteAnnotationByShareCode(share_code, comment_id) {
      return Http.axDelete(`${apiHost}/team_space_share/auth/${share_code}/comments/${comment_id}/delete`)
    },
  },
  member: {
    // 获取成员列表
    getMemberList(space_id) {
      return Http.get(`${apiHost}/team_spaces/${space_id}/members`)
    },
    // 移除成员
    removeMember(space_id, member_id) {
      return Http.axDelete(`${apiHost}/team_spaces/${space_id}/members/${member_id}/remove_member`)
    },
    // 修改成员/资源目录/文件夹/文件权限
    modifyPermission(space_id, member_id, params) {
      function buildQueryString(params) {
        const searchParams = new URLSearchParams()
        // 必选参数
        searchParams.append('permission_type', params.permission_type)
        // 可选参数
        if (params.object_id) {
          searchParams.append('object_id', params.object_id)
        }
        if (params.object_type) {
          searchParams.append('object_type', params.object_type)
        }
        // 将URLSearchParams对象转换为字符串
        return searchParams.toString()
      }

      const queryString = buildQueryString(params)
      const url = `${apiHost}/team_spaces/${space_id}/members/${member_id}/modify_permission?${queryString}`
      return Http.patch(url)
    },
    // 生成邀请链接
    getInvitationLink(space_id, permission_type) {
      return Http.get(`${apiHost}/team_spaces/${space_id}/invitation_link?permission_type=${permission_type}`)
    },
    // 获取邀请信息
    getInvitationInfo(space_id, invitation_key) {
      return Http.get(`${apiHost}/team_spaces/${space_id}/invitation_info?invitation_key=${invitation_key}`)
    },
    // 通过邀请链接加入团队空间
    joinTeamSpaces(invitation_key) {
      return Http.post(`${apiHost}/team_spaces/join?invitation_key=${invitation_key}`)
    },
    // 查询权限组与权限项对应关系
    getPermissionGroups() {
      return Http.get(`${apiHost}/team_spaces/permission_groups`)
    },
    // 查询空间内全部成员对具体对象的权限
    getSpaceMembersPermissions(space_id, params) {
      return Http.get(`${apiHost}/team_spaces/${space_id}/members/objects/permissions`, params)
    }
  },
  software: {
    // 获取可筛选的软件版本列表
    softwareVersionList(params) {
      return Http.get(`${apiHost}/team_space/${params.space_id}/content/space_resources/filters/software_versions`, params)
    },
    // 获取可筛选的软件版本列表
    // params {software_code}
    softwareVersionNameMappingList(space_id, params) {
      return Http.get(`${apiHost}/team_space/${space_id}/content/space_resources/filters/all_software_versions`, params)
    },
  },
  /** store服务 - 文件上传、获取文件等 **/
  store: {
    // 通过MD5获取StoreId
    getStoreId: (md5) => {
      return Http.get(`${apiHost}/stores/id?md5=${md5}`)
    },
    // 通过objectKey获取StoreId
    getStoreIdByKey: (params) => {
      return Http.post(`${apiHost}/stores`, params)
    },
    uploadPolicy: (params) => {
      return Http.post(`${apiHost}/stores/post_policy`, params)
    },
    // 根据StoreId获取文件下载url
    getUrlByStoreId(store_id) {
      return Http.get(`${apiHost}/stores/${store_id}/download_url`)
    }
  },
  // 3D展示相关接口
  threeD: {
    // 获取viewToken（Bimface渲染时需要）
    viewToken(space_resource_id) {
      return Http.get(`${apiHost}/v1/shop_components/${space_resource_id}/view_token`)
    },
    // 获取Gac的三维显示数据
    gacDisplayData(params) {
      return Http.post(`${apiHost}/digital_components/gcmp_server/display_data`, params)
    },
  },
  downgrade: {
    // 发起族降级
    startDowngrade(params) {
      return Http.post(`${apiHost}/private/downgrades`, params)
    },
    // 获取族降级
    getDowngrades(params) {
      return Http.get(`${apiHost}/private/downgrades`, params)
    },
    // 获取族降级下载地址
    getDownloadUrl(id) {
      return Http.get(`${apiHost}/private/downgrades/${id}/download_url`)
    },
  },
  global: {
    // 检测是否存在用户反馈访问记录
    checkFeedbackExists(query = {}) {
      return Http.get(`${apiHost}/feedback/exists`, query)
    },
    // 提交用户反馈
    feedback(params = {}) {
      return Http.post(`${apiHost}/feedback`, params)
    },
  },
}
export default {
  newApi,
  install: (Vue) => {
    Vue.prototype.$api = newApi
  },
  inject: (Store) => {
    Store.prototype.$api = newApi
  }
}
